import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Backpack `Settlement` レスポンススキーマ */
export const settlementSchema = z.object({
  /** 対象 user ID */
  userId: z.number(),
  /** 対象 subaccount ID */
  subaccountId: z.number().nullish(),
  /** 精算数量 (USDC 建て、受取は正 / 支払いは負) */
  quantity: decimalSchema,
  /** 精算の発生元 (例: RealizePnl / FundingPayment / TradingFees) */
  source: z.string(),
  /** 精算時刻 (naive ISO date-time, UTC) */
  timestamp: z.string(),
  /** 対象ポジション ID (funding / 実現損益の場合のみ) */
  positionId: z.string().nullish(),
  /** エンジンのシーケンス番号 */
  engineSequence: z.number().nullish(),
})

export const settlementsResponseSchema = z.array(settlementSchema)

export type Settlement = z.infer<typeof settlementSchema>
